module.exports = __webpack_public_path__ + "img/product-teacher-fbzy-01.9872833e.png";